@if (isLeafOptionsLevel() && itemSelected > 0) {
  <div [formGroup]="defForm">
    <ng-container [formArrayName]="'' + controlId">
      <div class="form-group row" formGroupName="0">
        <label for="dinamicSelect" class="col-sm-5 col-form-label">
          @if (labeltext) {
            <span class="">
              {{ labeltext }}
            </span>
          }
          @if (required) {
            <span class="text-danger">
              &#10033;
            </span>
          }
        </label>
        <div class="col-sm-7" formArrayName="sub">
          @for (field of fields; track field; let index = $index) {
            <div>
              @if (index + 1 == controlLevel && hasSubControlAt(index, field)) {
                <div [formGroupName]="index">
                  @if (searchable) {
                    <div class="autocomplete-container">
                      <input
                        type="text"
                        class="form-control"
                        [value]="searchText"
                        placeholder="Escriba para buscar..."
                        autocomplete="off"
                        (input)="onSearchInput($event, subs)"
                        (focus)="onSearchFocus(subs)"
                        (blur)="onSearchBlur()">
                      <select class="tree-select-native" [required]="required" [formControlName]="field"
                        (change)="showChildsTest($event.target.value)" tabindex="-1" aria-hidden="true">
                        <option value="">Seleccionar</option>
                        @for (value of subs; track value) {
                          <option [value]="'' + value.id">
                            {{ value.name }}
                          </option>
                        }
                      </select>
                      @if (showOptions && filteredOptions.length > 0) {
                        <div class="autocomplete-options">
                          @for (value of filteredOptions; track value.id; let i = $index) {
                            <div
                              class="autocomplete-option"
                              [class.selected]="i === selectedOptionIndex"
                              (mousedown)="onSearchOptionMouseDown($event, value, field)"
                              (mouseenter)="selectedOptionIndex = i">
                              {{ value.name }}
                            </div>
                          }
                        </div>
                      }
                    </div>
                  } @else {
                    <select class="form-control" [required]="required" [formControlName]="field"
                      (change)="showChildsTest($event.target.value)">
                      <option value="">Seleccionar</option>
                      @for (value of subs; track value) {
                        <option [value]="'' + value.id">
                          {{ value.name }}
                        </option>
                      }
                    </select>
                  }
                </div>
              }
            </div>
          }
        </div>
      </div>
    </ng-container>
  </div>
}
@for (select of subs; track select; let index = $index) {
  <div [formGroup]="defForm">
    @if (!isLeafOptionsLevel() && +select['id'] === +itemSelected && select['sub'] !== undefined) {
      <ng-container [formArrayName]="'' + controlId">
        <div class="form-group row" formGroupName="0">
          <label for="dinamicSelect" class="col-sm-5 col-form-label">
            @if (labeltext) {
              <span class="">
                {{labeltext}}
              </span>
            }
            @if (required) {
              <span class="text-danger">
                &#10033;
              </span>
            }
          </label>
          <div class="col-sm-7" formArrayName="sub">
            @for (field of fields; track field; let index = $index) {
              <div>
                @if (index + 1 == controlLevel && hasSubControlAt(index, field)) {
                  <div [formGroupName]="index">
                    @if (searchable) {
                      <div class="autocomplete-container">
                        <input
                          type="text"
                          class="form-control"
                          [value]="searchText"
                          placeholder="Escriba para buscar..."
                          autocomplete="off"
                          (input)="onSearchInput($event, select['sub'])"
                          (focus)="onSearchFocus(select['sub'])"
                          (blur)="onSearchBlur()">
                        <select class="tree-select-native" [required]="required" [formControlName]="field"
                          (change)="showChildsTest($event.target.value)" tabindex="-1" aria-hidden="true">
                          <option value="">Seleccionar</option>
                          @for (value of select['sub']; track value) {
                            <option [value]="'' + value.id">
                              {{ value.name }}
                            </option>
                          }
                        </select>
                        @if (showOptions && filteredOptions.length > 0) {
                          <div class="autocomplete-options">
                            @for (value of filteredOptions; track value.id; let i = $index) {
                              <div
                                class="autocomplete-option"
                                [class.selected]="i === selectedOptionIndex"
                                (mousedown)="onSearchOptionMouseDown($event, value, field)"
                                (mouseenter)="selectedOptionIndex = i">
                                {{ value.name }}
                              </div>
                            }
                          </div>
                        }
                      </div>
                    } @else {
                      <select class="form-control" [required]="required" [formControlName]="field"
                        (change)="showChildsTest($event.target.value)">
                        <option value="">Seleccionar</option>
                        @for (value of select['sub']; track value) {
                          <option [value]="'' + value.id" (click)="showChilds(value['id'])">
                            {{ value.name }}
                          </option>
                        }
                      </select>
                    }
                  </div>
                }
              </div>
            }
          </div>
        </div>
        @if (shouldRecurseIntoChildren(select)) {
          <app-tree-select [subs]="getChilds(select)" [itemSelected]="selectedId" [parentForm]="parentForm"
            [controlId]="controlId" controlLevel={{nextLevel()}} [required]="required" [labeltext]="nextName"
            [fieldSelected]="fieldSelected" [searchable]="searchable" (selectChange)="selectChange.emit($event)">
          </app-tree-select>
        }
      </ng-container>
    }
  </div>
}
